// helper function to get an element's exact position
const getPosition = (el) => {
    let xPosition = 0;
    let yPosition = 0;

    while (el) {
        if (el.tagName === "BODY") {
            // deal with browser quirks with body/window/document and page scroll
            let xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
            let yScrollPos = el.scrollTop || document.documentElement.scrollTop;

            xPosition += (el.offsetLeft - xScrollPos + el.clientLeft);
            yPosition += (el.offsetTop - yScrollPos + el.clientTop);
        } else {
            xPosition += (el.offsetLeft - el.scrollLeft + el.clientLeft);
            yPosition += (el.offsetTop - el.scrollTop + el.clientTop);
        }

        el = el.offsetParent;
    }
    return {
        x: xPosition,
        y: yPosition
    };
};

const getCenter = (el) => {
    const position = getPosition(el);

    return {
        x: position.x + el.clientWidth / 2,
        y: position.y + el.clientHeight / 2
    }
};

const getAngleFromCoords = (center, target) => {
    return ((Math.atan2(center.y - target.y, center.x - target.x) * 180 / Math.PI) + 270) % 360;
};

const getDistanceBetweenPoints = (point1, point2) => {
    const x1 = point1.x, y1 = point1.y, x2 = point2.x, y2 = point2.y;

    return Math.sqrt( (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1) );
};

export {getPosition, getCenter, getAngleFromCoords, getDistanceBetweenPoints};



// WEBPACK FOOTER //
// ./src/utils/Coordinates.js